import eventMixin from '../lib/eventMixin';
import ThemeBlockFullWidthProjectSlideshow from './themeBlockFullWidthBannerSlideshow';
import ThemeBlockTwoPanelBanner from './themeBlockTwoPanelBanner';
import ThemeBlockThreePanelBanner from './themeBlockThreePanelBanner';
import Logger from "../utilities/Logger";

export default class ThemeFlexibleContent {

	constructor(dom) {
		const NAME = 'ThemeFlexibleContent';
		Logger.log(`${NAME} > init`);

		var self = this;

		this.dom = dom;

		// Gather all ThemeFlexibleContents
		const themeBlockFullWidthBannerSlideshows = this.dom.querySelectorAll('[data-theme-block-full-width-banner-slideshow]');
		themeBlockFullWidthBannerSlideshows.forEach((dom) => {
			const slideshow = new ThemeBlockFullWidthProjectSlideshow(dom);
		});

		// Gather all themeBlockTwoPanelBanners
		const themeBlockTwoPanelBanners = this.dom.querySelectorAll('[data-theme-block-two-panel-banner]');
		themeBlockTwoPanelBanners.forEach((dom) => {
			const block = new ThemeBlockTwoPanelBanner(dom);
		});

		// Gather all ThemeBlockThreePanelBanners
		const ThemeBlockThreePanelBanners = this.dom.querySelectorAll('[data-theme-block-three-panel-banner]');
		ThemeBlockThreePanelBanners.forEach((dom) => {
			const block = new ThemeBlockThreePanelBanner(dom);
		});
	}
}

// Mixins
Object.assign(ThemeFlexibleContent.prototype, eventMixin);
